import React from 'react';
import { MenuItem } from '@material-ui/core';
import { SelectContainer, StyledSelect, SelectLabel, ErrorText as SelectErrorText, } from './styles';
export var CustomSelect = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, options = _a.options, _b = _a.placeholder, placeholder = _b === void 0 ? 'Seleccionar...' : _b, _c = _a.error, error = _c === void 0 ? false : _c, errorText = _a.errorText, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    return (React.createElement(SelectContainer, null,
        label && React.createElement(SelectLabel, null, label),
        React.createElement(StyledSelect, { value: value || '', onChange: function (e) { return onChange(e.target.value); }, displayEmpty: true, error: error, disabled: disabled },
            React.createElement(MenuItem, { value: "", disabled: true }, placeholder),
            options.map(function (option) { return (React.createElement(MenuItem, { key: option.value, value: option.value }, option.label)); })),
        error && errorText && React.createElement(SelectErrorText, null, errorText)));
};
export default CustomSelect;
